<template>
	<span
		class="kk-icon-with-badge"
		:class="[
			`kk-icon-with-badge--${ size }`,
			{
				'kk-icon-with-badge--text': !!badgeValue,
				'kk-icon-with-badge--dot': !badgeValue,
			}
		]"
	>
		<KkIcon
			class="kk-icon-with-badge__icon"
			:name="iconName"
			:size="size"
		/>
		<KkBadge
			v-if="isShowBadge"
			class="kk-icon-with-badge__badge"
			:value="badgeValue"
			:dot-size="BADGE_DOT_SIZE_MAP[size]"
		/>
	</span>
</template>

<script>
import KkBadge from '../../KkBadge';
import KkIcon from '../../KkIcon';

const BADGE_DOT_SIZE_MAP = {
	'2xs': 'md',
	'xs': 'md',
	'sm': 'md',
	'md': 'md',
	'lg': 'md',
	'xl': 'lg',
}

export default {
	name: 'KkIconWithBadge',
	components: {
		KkBadge,
		KkIcon,
	},
	props: {
		iconName: {
			type: String,
			required: true,
		},
		size: {
			type: String,
			default: 'md',
		},
		isShowBadge: {
			type: Boolean,
			default: true,
		},
		badgeValue: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {
			BADGE_DOT_SIZE_MAP,
		};
	},
}
</script>
